export const searchRoute = (route: string): string | null => {
  const regex = /\/[-\w]+/i

  return (route !== '/' && regex.exec(route)?.[0]) || null
}

export const filterRoute = (route: string, routes: string[]): string[] =>
  Object.values(routes).filter(el => route === searchRoute(el))
